import { memo } from 'react';

import { useCountdown } from 'src/utils';

import styles from './Timer.module.css';

type TpTimerProps = {
  targetTimeInMs: number;
  showMinutes?: boolean;
  onCountdownComplete?: () => void;
};

export const Timer = memo((props: TpTimerProps) => {
  const { onCountdownComplete, targetTimeInMs, showMinutes } = props;
  const [_, minutes, seconds] = useCountdown({
    targetDate: targetTimeInMs,
    onComplete: () => {
      onCountdownComplete && onCountdownComplete();
    },
  });

  return (
    <span className={styles.text}>
      {showMinutes && `${minutes}:`}
      {seconds}
    </span>
  );
});

Timer.displayName = 'Timer';
